import StandardIcons from './standard'

export default StandardIcons.concat([
    ['send', require(`@material-icons/svg/svg/send/baseline.svg`)],
    ['logout', require(`@material-icons/svg/svg/logout/baseline.svg`)],
    ['ios_share', require(`@material-icons/svg/svg/ios_share/baseline.svg`)],
    ['install_desktop', require(`@material-icons/svg/svg/install_desktop/baseline.svg`)],
    ['install', 'install_desktop'],
    ['install_mobile', require(`@material-icons/svg/svg/install_mobile/baseline.svg`)],

    ['person', require(`@material-icons/svg/svg/person/baseline.svg`)],
    ['group', require(`@material-icons/svg/svg/group/baseline.svg`)],
    ['email', require(`@material-icons/svg/svg/email/baseline.svg`)],
    ['admin_panel_settings', require(`@material-icons/svg/svg/admin_panel_settings/baseline.svg`)],

    ['more_vert', require(`@material-icons/svg/svg/more_vert/baseline.svg`)],
    ['more_horz', require(`@material-icons/svg/svg/more_horiz/baseline.svg`)],

    ['library_add_check', require('@material-icons/svg/svg/library_add_check/baseline.svg')],
    ['tune', require('@material-icons/svg/svg/tune/baseline.svg')],
    ['filter', require('@material-icons/svg/svg/filter_alt/baseline.svg')],
    ['warning', require('@material-icons/svg/svg/warning/baseline.svg')],
    ['error', require('@material-icons/svg/svg/error/baseline.svg')]
])